module.exports = __webpack_public_path__ + "img/about9.eee783e3.jpg";